import React, { useRef, useEffect } from "react";
import "./AboutSection.css";
import vide from "../../Image/firstVideo.mp4";

// Import three line images
import xo_left from "../../Image/AboutSection/ThreeLine/xo-1.png";
import xo_right from "../../Image/AboutSection/ThreeLine/xo.png";

import image01 from "../../Image/AboutSection/ThreeIcon/01.png";
import image02 from "../../Image/AboutSection/ThreeIcon/02.png";
import image03 from "../../Image/AboutSection/ThreeIcon/03.png";

const AboutSection = () => {
  const video_ref = useRef(null);

  useEffect(() => {
    const video = video_ref.current;
    if (!video) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            video.play();
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.5 },
    );

    observer.observe(video);

    return () => {
      observer.unobserve(video);
      observer.disconnect();
    };
  }, []);

  return (
    <section className="about_section">
      <div className="about_container">
        {/* Top Row: Title Left + Features Right */}
        <div className="about_top_row">
          {/* Left: Title */}
          <div className="about_title_wrapper">
            <h2 className="about_title">Privacy</h2>
          </div>

          {/* Right: Features */}
          <div className="about_features_wrapper">
            <div className="about_features_list">
              {/* Feature 1 - Cloud Off Icon (Cloud with slash) */}
              <div className="about_feature_item">
                <img
                  src={image01}
                  alt="Privacy icon"
                  className="feature_icon"
                />
                <p className="feature_text">
                  Your pictures are never uploaded to the cloud or seen by third
                  parties.
                </p>
              </div>

              {/* Feature 2 - Trash Icon */}
              <div className="about_feature_item">
                <img
                  src={image03}
                  alt="Privacy icon"
                  className="feature_icon"
                />
                <p className="feature_text">
                  Your pictures are auto-deleted right after your session.
                </p>
              </div>

              {/* Feature 3 - Privacy Shield Icon */}
              <div className="about_feature_item">
                <img
                  src={image02}
                  alt="Privacy icon"
                  className="feature_icon"
                />
                <p className="feature_text">
                  The system uses special, in-house technology built for speed
                  and privacy.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Row: Full Width Video */}
        <div className="about_video_wrapper">
          {/* Three line image - Left side */}
          <img
            src={xo_left}
            alt=""
            className="about_three_line three_line_left"
          />

          <video ref={video_ref} className="about_video" loop muted playsInline>
            <source src={vide} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          {/* Three line image - Right side */}
          <img
            src={xo_right}
            alt=""
            className="about_three_line three_line_right"
          />
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
